class CollectionInfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.onClick.bind(this));
    this.container = document.getElementById('ProductGrid');
    this.isLoading = false;

    document.addEventListener('DOMContentLoaded', (event) => {
      const hash = window.location.hash;
      if (hash) {
        setTimeout(() => document.querySelector(hash).closest('.card-product').scrollIntoView(), 50);
      }
    });
  }

  onClick(event) {
    if (this.isLoading) return;
    const page = event.target.getAttribute('data-product-page');
    if (page) {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('page', page);
      history.replaceState(
        { urlParams: urlParams.toString(), page },
        '',
        `${window.location.href.split('?')[0]}?${urlParams.toString()}#${event.target.getAttribute('id')}`
      );
    }

    const loadTrigger = event.target.closest('[data-load-id]');
    const id = loadTrigger && loadTrigger.getAttribute('data-load-id');
    if (id) {
      const direction = loadTrigger.getAttribute('data-load-direction');
      if (direction === 'more') {
        this.setLoading();
        this.loadMore(id);
        return;
      }
      this.setLoading();
      const urlParams = new URLSearchParams(window.location.search);
      if (!this.page) {
        this.page = parseInt(urlParams.get('page')) || 1;
      }
      this.page = this.page - 1;
      urlParams.set('page', this.page);
      const pageUrl = `${window.location.href.split('?')[0]}?${this.page > 1 ? urlParams.toString() : ''}`;
      const fetchUrl = `${pageUrl}&section_id=${id}`;
      history.replaceState({ urlParams: urlParams.toString() }, '', pageUrl);
      this.fetchData(fetchUrl, direction);
    }
  }

  loadMore(sectionId) {
    const batchSize = parseInt(this.container.dataset.batchSize, 10) || 12;
    if (!this.nextShopPage) {
      this.nextShopPage = parseInt(this.container.dataset.nextShopPage, 10) || 2;
    }
    if (!this.pending) this.pending = [];

    const appendBatch = async () => {
      let added = 0;
      let firstNewLink = null;

      while (added < batchSize) {
        if (this.pending.length === 0) {
          if (this.noMorePages) break;
          const page = await this.fetchShopPage(sectionId, this.nextShopPage);
          this.nextShopPage += 1;
          this.pending.push(...page.lis);
          if (!page.hasMore) this.noMorePages = true;
          if (page.lis.length === 0) break;
        }

        const li = this.pending.shift();
        const link = li.querySelector('a[id]');
        if (link && document.getElementById(link.id)) continue;
        this.container.appendChild(li);
        if (!firstNewLink && link) firstNewLink = link;
        added += 1;
      }

      this.updateViewedCount();
      if (added < batchSize && this.pending.length === 0) {
        const more = this.querySelector('#ProductLoadMore');
        if (more) more.style.display = 'none';
      }
      if (firstNewLink) firstNewLink.focus({ preventScroll: true });
      this.finishLoading();
    };

    appendBatch().catch((err) => {
      if (err) console.log(err);
      document.dispatchEvent(new CustomEvent('rendering:error'));
      this.finishLoading();
    });
  }

  fetchShopPage(sectionId, page) {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('page', page);
    urlParams.delete('section_id');
    const pageUrl = `${window.location.href.split('?')[0]}?${urlParams.toString()}`;
    history.replaceState({ urlParams: urlParams.toString() }, '', pageUrl);
    return fetch(`${pageUrl}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser().parseFromString(html, 'text/html');
        const grid = parser.getElementById('ProductGrid');
        const lis = grid ? [...grid.children].filter((node) => node.tagName === 'LI') : [];
        const hasMore = !!parser.querySelector('#ProductLoadMore a[data-load-direction="more"]');
        return { lis, hasMore };
      });
  }

  updateViewedCount() {
    const paragraph = this.querySelector('[data-collection-viewed]');
    if (!paragraph) return;
    const count = [...this.container.children].filter((node) => node.tagName === 'LI').length;
    const previous = paragraph.dataset.collectionViewed;
    if (previous) {
      paragraph.textContent = paragraph.textContent.replace(previous, String(count));
    }
    paragraph.dataset.collectionViewed = String(count);
  }

  setLoading() {
    const buttons = this.querySelectorAll('[data-load-id]');
    buttons.forEach((button) => {
      button.setAttribute('aria-disabled', true);
      button.setAttribute('data-loading', true);
    });
    this.isLoading = true;
  }

  fetchData(url, direction) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        this.renderData(html, direction);
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
        document.dispatchEvent(new CustomEvent('rendering:error'));
        this.finishLoading();
      });
  }

  renderData(html, direction) {
    const parser = new DOMParser().parseFromString(html, 'text/html');
    const firstElement = parser.querySelector('.card-product a');
    [];
    const firstElementLink = firstElement.getAttribute('href');
    const content = parser.getElementById('ProductGrid').innerHTML;
    let htmlPosition = 'beforeend';
    let paginationId = 'ProductLoadMore';
    if (direction === 'previous') {
      htmlPosition = 'afterbegin';
      paginationId = 'ProductLoadPrevious';
    }
    const paginationEl = parser.getElementById(paginationId);
    if (paginationEl) {
      this.querySelector(`#${paginationId}`).innerHTML = paginationEl.innerHTML;
    } else {
      this.querySelector(`#${paginationId}`).style.display = 'none';
    }
    this.container.insertAdjacentHTML(htmlPosition, content);
    this.querySelector(`a[href="${firstElementLink}"]`).focus({ preventScroll: true });
    this.finishLoading();
  }

  finishLoading() {
    this.isLoading = false;
    const buttons = this.querySelectorAll('[data-load-id]');
    buttons.forEach((button) => {
      button.removeAttribute('data-loading');
      button.removeAttribute('aria-disabled');
      const spinner = button.querySelector('.loading__spinner');
      if (spinner) spinner.classList.add('hidden');
    });
  }
}
customElements.define('collection-infinite-scroll', CollectionInfiniteScroll);
